module.exports = {"530426001":"双江街道","530426002":"小街街道","530426103":"甸中镇","530426104":"化念镇","530426105":"塔甸镇","530426201":"岔河乡","530426202":"大龙潭乡","530426203":"富良棚乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530426.json
// module id = 2705
// module chunks = 0